import { jsxs as C, jsx as e } from "react/jsx-runtime";
import { a as I } from "../../core-DVmjA3_O.js";
import { _ as l } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import L from "../Description/index.js";
import A from "../InlineLayout/index.js";
import N from "../InputError/index.js";
import q from "../InputLabel/index.js";
import D from "../Label/index.js";
import P from "../ListView/index.js";
import T from "../../hooks/useSpacingToken.js";
import '../../index31.css';const U = "_input-container_1bo86_1", j = "_input-section_1bo86_4", B = "_general-variant_1bo86_11", z = "_disabled_1bo86_18", E = "_with-update-highlight_1bo86_26", M = "_form-variant_1bo86_27", F = "_transparent-variant_1bo86_28", G = "_with-add-highlight_1bo86_36", J = "_with-remove-highlight_1bo86_46", K = "_errored_1bo86_61", Q = "_read-only_1bo86_67", t = {
  inputContainer: U,
  inputSection: j,
  generalVariant: B,
  disabled: z,
  withUpdateHighlight: E,
  formVariant: M,
  transparentVariant: F,
  withAddHighlight: G,
  withRemoveHighlight: J,
  errored: K,
  readOnly: Q
};
function ot(p) {
  const {
    containerRef: g,
    inputSectionRef: c,
    actions: m,
    className: _,
    disabled: a,
    error: i,
    errorOnTooltip: o = !1,
    hint: d,
    icons: f,
    input: u,
    label: b,
    readOnly: w,
    required: v,
    variant: r = "form",
    withAsterisk: V,
    spacing: s,
    prevValue: h,
    withPrevValue: y,
    highlightMode: n,
    withPadding: H,
    withBackground: R,
    withDarkBackground: O,
    withoutInputSectionPadding: S
  } = p, k = V ?? v, x = T({
    spacing: s,
    offset: r === "transparent" ? -2 : -3,
    modes: S ? [] : ["padding-inline"]
  });
  return /* @__PURE__ */ C(
    P,
    {
      elementRef: g,
      layout: "block",
      className: l(
        t.inputContainer,
        !!i && t.errored,
        w && t.readOnly,
        r === "form" && t.formVariant,
        r === "general" && t.generalVariant,
        r === "transparent" && t.transparentVariant,
        a && t.disabled,
        n === "add" && t.withAddHighlight,
        n === "update" && t.withUpdateHighlight,
        n === "remove" && t.withRemoveHighlight,
        _
      ),
      title: o && i && typeof i == "string" ? i : void 0,
      spacing: s,
      spacingOffset: -4,
      withBackground: R,
      withDarkBackground: O,
      withPadding: H,
      children: [
        /* @__PURE__ */ e(
          q,
          {
            disabled: a,
            required: k,
            children: b
          }
        ),
        /* @__PURE__ */ e(
          A,
          {
            className: l(
              t.inputSection,
              x
            ),
            elementRef: c,
            before: f,
            after: m,
            spacingOffset: -3,
            spacing: s,
            children: u
          }
        ),
        y && h && I(n) && /* @__PURE__ */ e(D, { strong: !0, children: h }),
        !i && !o && d && /* @__PURE__ */ e(
          L,
          {
            withLightText: !0,
            textSize: "sm",
            children: d
          }
        ),
        i && /* @__PURE__ */ e(
          N,
          {
            disabled: a,
            floating: o,
            children: i
          }
        )
      ]
    }
  );
}
export {
  ot as default
};
